import VolumeUpIcon from '@mui/icons-material/VolumeUp';
import { IconButton, Theme } from '@mui/material';
import { makeStyles } from '@mui/styles';
import * as React from 'react';
import { useAppDispatch, useAppSelector } from '../../app/hooks';
import { messagingActions } from '../../reducers/messagingSlice';
import { selectIsPlaying } from '../../selectors/message';
import Colors from '../../utils/color';

const useStyles = makeStyles((theme: Theme) => ({
  iconContainer: {
    width: '40px',
    height: '100%',
    padding: '0px !important',
    display: 'flex',
    flexDirection: 'column',
    margin: '4px !important',
  },
  icon: {
    color: Colors.dim,
    width: '100% !important',
    height: '40px !important',
    padding: '8px',
    paddingRight: '4px',
    borderRadius: '4px',
  },
  active: {
    color: Colors.cerulean,
    width: '100% !important',
    height: '50px !important',
    padding: '2px',
    paddingRight: '4px',
    borderRadius: '4px',
  },
}));

export const Player = () => {
  const classes = useStyles();
  const dispatch = useAppDispatch();
  const isPlaying = useAppSelector(selectIsPlaying);
  const toggleAudio = async () => {
    if (isPlaying) {
      dispatch(messagingActions.setIsPlaying(false));
    } else {
      dispatch(messagingActions.setIsPlaying(true));
    }
  };

  return (
    <IconButton onClick={() => toggleAudio()} className={classes.iconContainer}>
      {
        <>
          <VolumeUpIcon
            fontSize="small"
            className={isPlaying ? classes.active : classes.icon}
          />
        </>
      }
    </IconButton>
  );
};
